import(/* webpackMode: "eager", webpackExports: ["TermlyPolicy","TermsAndConditionsPolicyDataId"] */ "/codebuild/output/src4290575114/src/apps/wrap.gifts/src/services/Termly/TermlyPolicy.tsx");
